export { default as Input } from './Input.vue'

export const SIZE_CLASS = {
  sm: 'h-[2.125rem] px-3 text-sm',
  md: 'h-10 px-3 text-base',
  lg: 'h-[2.875rem] px-3 text-lg',
} as const

export type InputSize = keyof typeof SIZE_CLASS
